import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { TestModeEnum } from '@doltech/utils/lib/constants';
import dynamic from 'next/dynamic';
import * as React from 'react';
import styled from 'styled-components';

import { DiagramLabelCompletionProps } from '../../../student-do-test-questions/DiagramLabelCompletionAnswer';

const DiagramLabelCompletionAnswer = dynamic<any>(
  import('../../../student-do-test-questions/DiagramLabelCompletionAnswer').then(
    (mod) => mod.DiagramLabelCompletionAnswer
  )
);

const Main = styled.div`
  div.ant-spin-nested-loading > div > div > .circle-spot {
    background-color: ${colorsV2.black100};
    color: ${colorsV2.white100};
  }
  .input-blank > div > div.editor-content-wrapper .input-display {
    padding: 0;
    border: none;
    .question-option.circle-text {
      border-radius: 50%;
      background-color: ${colorsV2.gray100};
      > span {
        color: ${colorsV2.white100};
      }
    }
    .textarea > div {
      margin-right: 8px;
    }
    input {
      user-select: none;
      pointer-events: none;
    }
  }
`;

export const DiagramLabelCompletionAnswerSubject = (props: DiagramLabelCompletionProps) => {
  return (
    <Main>
      <DiagramLabelCompletionAnswer {...props} mode={TestModeEnum.VIEW_TEST_QUESTION} />
    </Main>
  );
};
